module.exports = __webpack_public_path__ + "static/img/0.-HSBC-BWF-World-Tour-Inside-Page.5e8dd17.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/0.-HSBC-BWF-World-Tour-Inside-Page.png
// module id = iYfG
// module chunks = 1